import React, { FC } from 'react';

import GroupChannelListHeader from '@sendbird/uikit-react/GroupChannelList/components/GroupChannelListHeader';
import Icon, { IconTypes } from '@sendbird/uikit-react/ui/Icon';
import { Box } from '@mui/system';

import GroupChannelListTitle from '../../../Admin/ChatWindow/GroupChannelListTitle';

import styles from './styles';

interface IGroupHeaderBase {
  showDialog?: (() => void) | null;
  customMiddle?: () => JSX.Element;
}

const GroupHeaderBase: FC<IGroupHeaderBase> = ({
  showDialog,
  customMiddle,
}) =>
  (
    <GroupChannelListHeader
      renderMiddle={customMiddle || GroupChannelListTitle}
      renderIconButton={() =>
        (
        // eslint-disable-next-line react/jsx-no-useless-fragment
          <>
            {showDialog && (
            <Box onClick={showDialog} sx={styles.create}>
              <Icon type={IconTypes.CREATE} fillColor="PRIMARY" />
            </Box>
            )}
          </>
        )}
    />
  );

export default GroupHeaderBase;
